import React from 'react'
import { SanityContactForm } from '../../../../../types/generated/graphql-types'
import { sanityContactFormToContactFormProps } from '../../../../mapping/FormMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { ContactForm } from '../../../blocks/ContactForm/ContactForm'
import { MarketSection } from '../../../MarketSection'

type ContactFormSerializerProps = SanityContactForm &
  BlockWithId & {
    marketSection?: boolean
  }

export const ContactFormSerializer = ({
  id,
  marketSection = true,
  ...props
}: ContactFormSerializerProps): JSX.Element => {
  const formId = id ? `${id}-form` : `${props._key}-form`

  if (!!marketSection) {
    return (
      <MarketSection applyGrid={false} id={id}>
        <ContactForm id={formId} {...sanityContactFormToContactFormProps(props)} />
      </MarketSection>
    )
  } else {
    return (
      <div id={id}>
        <ContactForm id={formId} {...sanityContactFormToContactFormProps(props)} />
      </div>
    )
  }
}
